import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

interface ReusableDialogProps {
  open: boolean;                  // control visibility
  title: string;                   // dialog title
  content: React.ReactNode;        // dialog content
  onCancel: () => void;            // cancel handler
  cancelText?: string;             // optional cancel button text
}

export default function ReusableDialog({
  open,
  title,
  content,
  onCancel,
  cancelText = "Cancel",
}: ReusableDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {content}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="error">
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
